import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";
import {listFromMap} from "../../../helper/list.helper";

@Component({
  selector: 'app-coupon-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './coupon-edit.component.html',
  styleUrl: './coupon-edit.component.scss'
})
export class CouponEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected cdr: ChangeDetectorRef,
              protected crudService: CrudService) {

  }
  clientList: {value: string; label: string}[] = [];

  editLink = '/dashboard/coupon-edit/';
  menuLink = '/dashboard/coupon';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'coupon';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {} as any;
    }

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
  marksTargets = [
    'inst', 'fb', 'x', 'don', 'goal', 'raised', 'pay'
  ];
  soc = ['inst', 'fb', 'x'];



  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Manager Role)',
        configs: [
          {field: 'key', name: 'Key', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'total', name: 'Total amount', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'goal', name: 'Goal amount', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'imgTmp1', name: 'Template OF The Hello Page', type: EInputType.FILE_WITH_MARKS, validators: []},
          {field: 'imgTmp2', name: 'Template OF The Thank You Page', type: EInputType.FILE, validators: []},

          ...this.marksTargets.map(key => (
            {field: key + 'X', name: 'X of Hello Page ' + key, type: EInputType.TEXT, validators: []}
          )),
          ...this.marksTargets.map(key => (
            {field: key + 'Y', name: 'Y of Hello Page ' + key, type: EInputType.TEXT, validators: []}
          )),
          ...this.soc.map(key => (
            {field: key + 'Url', name: 'Url of ' + key, type: EInputType.TEXT, validators: []}
          )),

          {field: 'helloPageCss', name: 'Hello Page CSS', type: EInputType.TEXTAREA, validators: []},
          {field: 'helloPageStartTemplate', name: 'Hello Page Start', type: EInputType.TEXTAREA, validators: []},
          {field: 'helloPageEndTemplate', name: 'Hello Page End', type: EInputType.TEXTAREA, validators: []},
          {field: 'thankYouPageStartCss', name: 'Hello Thank You CSS', type: EInputType.TEXTAREA, validators: []},
          {field: 'thankYouPageStartTemplate', name: 'Hello Thank You Start', type: EInputType.TEXTAREA, validators: []},
          {field: 'thankYouPageEndTemplate', name: 'Hello Thank You End', type: EInputType.TEXTAREA, validators: []},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (Manager Role ' + item.name + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
